// Contas das comissões — UMA só fonte para Início, Negócios, Comissões, Relatórios, Concluídos,
// Ver processos e Ficha A4. Regras decididas pela Sónia (30/09/2026):
// - Previsão: proposta aceite / CPCV pedido. Comissão (garantida): a partir do CPCV assinado.
// - Total da comissão = valor gravado no processo (pode ter sido negociado); nunca recalculado.
// - Tudo em € do processo: reporting de cada lado e comissão de cada consultor.
// - Outra agência: a cinzento, nunca somada à equipa.
// - Consultor: vê o SEU reporting e as SUAS comissões. Líder: a soma dos consultores da equipa.
import { consultoresDoNegocio, contasComissao } from "./ProcessosCliente";

export const FASE_PREVISAO = ["proposta", "cpcv_pedido"];
export const FASE_CURSO = ["cpcv_assinado", "escritura_agendada", "direto_escritura", "financiamento", "cpcv"];
export const FASE_CONCLUIDO = ["escriturado", "vendido", "arrendado", "fechado"];

// "previsao" | "comissao" (garantida, em curso ou concluída) | null (cancelado/apagado/outro)
export function faseComissao(n) {
  if (!n || n.deleted_at || n.estado === "cancelado") return null;
  if (FASE_PREVISAO.includes(n.estado)) return "previsao";
  if (FASE_CURSO.includes(n.estado) || FASE_CONCLUIDO.includes(n.estado)) return "comissao";
  return null;
}
export const negocioConcluidoContas = (n) => !!n && !n.deleted_at && FASE_CONCLUIDO.includes(n.estado);

// Data a partir da qual a comissão conta como garantida (para filtros de período)
export const dataGarantida = (n) => n.data_cpcv_assinado || n.data_escritura_realizada || n.data_escritura_agendada || n.updated_at || n.created_at;
export const dataPrevisao = (n) => n.data_proposta || n.created_at;

const arred = (v) => Math.round(Number(v || 0) * 100) / 100;

// Contas de UM negócio: lados (equipa e externos) com reporting, comissão, recebido e em falta
export function contasNegocio(n, { propostas, comissoes, consultores, leads, recebimentos }) {
  const com = (comissoes || []).find(c => c.negocio_id === n.id && !c.deleted_at);
  const cons = consultoresDoNegocio(n, { propostas, consultores, leads });
  const contas = contasComissao(n, com, cons, { recebimentos });
  let linhas = contas ? contas.linhas : [];
  let total = contas ? contas.total : 0;
  let fase = faseComissao(n);
  // Negócio cancelado em que se cobrou um valor (ex.: acordo): esse valor conta como Comissão,
  // repartido pelos lados na mesma proporção da comissão original.
  const cobrado = Number(com?.comissao_cancelamento || 0);
  if (n && !n.deleted_at && n.estado === "cancelado" && cobrado > 0 && total > 0) {
    const f = cobrado / total;
    const r2 = (v) => v === null || v === undefined ? v : Math.round(Number(v) * f * 100) / 100;
    linhas = linhas.map(l => {
      const valor = r2(l.valor);
      return { ...l, reporting: r2(l.reporting), valor, porReceber: l.externo ? l.porReceber : Math.round(Math.max(0, Number(valor || 0) - Number(l.recebido || 0)) * 100) / 100 };
    });
    total = cobrado; fase = "comissao";
  }
  return { negocio: n, fase, comissao: com || null, total, linhas, cancelado: n?.estado === "cancelado" };
}

// Soma para quem está a ver. consultorId: só as linhas desse consultor (consultor, ou líder a filtrar);
// sem consultorId: todos os consultores da equipa (líder). Externos somados à parte (cinzento).
export function somarLinhas(contasLista, { consultorId = null, consultorNome = null } = {}) {
  const s = { negocios: 0, reporting: 0, valor: 0, recebido: 0, emFalta: 0, externo: 0, volume: 0, total: 0 };
  contasLista.forEach(c => {
    const meus = c.linhas.filter(l => !l.externo && (consultorId ? l.consultorId === consultorId : consultorNome ? l.nome === consultorNome : true));
    if (!meus.length) return;
    s.negocios++;
    s.volume += Number(c.negocio.valor_venda || 0);
    s.total += Number(c.total || 0);
    // Juntar as linhas de cada consultor (no pleno o mesmo consultor tem os dois lados: o recebido conta uma vez)
    const porConsultor = {};
    meus.forEach(l => {
      const k = l.consultorId || l.nome;
      const p = porConsultor[k] || (porConsultor[k] = { reporting: 0, valor: 0, recebido: Number(l.recebido || 0) });
      p.reporting += Number(l.reporting || 0); p.valor += Number(l.valor || 0);
    });
    Object.values(porConsultor).forEach(p => { s.reporting += p.reporting; s.valor += p.valor; s.recebido += p.recebido; s.emFalta += Math.max(0, p.valor - p.recebido); });
    // partilhas externas só contam para a líder (visão da equipa), sempre à parte
    if (!consultorId && !consultorNome) s.externo += c.linhas.filter(l => l.externo).reduce((a, l) => a + Number(l.reporting || 0), 0);
  });
  Object.keys(s).forEach(k => { s[k] = arred(s[k]); });
  return s;
}

// Resumo Comissão (garantida) e Previsão, com filtro opcional de período
export function resumoComissoes(negocios, ctx, { consultorId = null, consultorNome = null, desde = null, ate = null } = {}) {
  const noPeriodo = (d) => { if (!desde && !ate) return true; if (!d) return false; const t = new Date(d); return (!desde || t >= desde) && (!ate || t <= ate); };
  const todas = (negocios || []).map(n => contasNegocio(n, ctx));
  const garantidas = todas.filter(c => c.fase === "comissao" && noPeriodo(dataGarantida(c.negocio)));
  const previsoes = todas.filter(c => c.fase === "previsao" && noPeriodo(dataPrevisao(c.negocio)));
  return {
    comissao: somarLinhas(garantidas, { consultorId, consultorNome }),
    previsao: somarLinhas(previsoes, { consultorId, consultorNome }),
    concluidos: somarLinhas(garantidas.filter(c => negocioConcluidoContas(c.negocio)), { consultorId, consultorNome }),
    garantidas, previsoes,
  };
}

// Negócios concluídos por consultor (o lado que cada um representou; num pleno conta uma vez)
export function concluidosPorConsultor(negocios, ctx) {
  const mapa = {};
  (negocios || []).filter(negocioConcluidoContas).forEach(n => {
    const ids = new Set(contasNegocio(n, ctx).linhas.filter(l => !l.externo && l.consultorId).map(l => l.consultorId));
    ids.forEach(id => { mapa[id] = (mapa[id] || 0) + 1; });
  });
  return mapa;
}
